// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

// toggle password
const togglePassword = document
            .querySelector('#togglePIN');
        const password = document.querySelector('#cardPIN');
        togglePassword.addEventListener('click', () => {
            // Toggle the type attribute using
            // getAttribure() method
            const type = password
                .getAttribute('type') === 'password' ?
                'text' : 'password';
            password.setAttribute('type', type);
            // Toggle the eye and bi-eye icon
            this.classList.toggle('bi-eye');
        });